@if (visibleInitialStatisticsBtn()) {
  <button
    [appIconStatus]="fetchIconStatus('advertisementInitialStatisticsStatus')"
    mat-stroked-button
    class="advertisement-statistics-btn"
    color="primary"
    (click)="openAdvertisementInitialStatisticsModal()"
  >
    Первичная статистика
  </button>
}
@for (field of advertisementStatisticFileButtons; track $index) {
  <button
    [appIconStatus]="fetchIconStatus(field.statusName || '')"
    mat-stroked-button
    color="primary"
    class="advertisement-statistics-btn"
    (click)="handleFileAction(field)"
  >
    {{ field.label }}
  </button>
}
<button
  mat-stroked-button
  color="primary"
  class="advertisement-statistics-btn"
  (click)="handleOpenFiles()"
>
  Открыть все файлы
</button>
